// Just enough H.264 Annex-B parsing for the return-feed decoder: find the
// NAL units, tell an IDR from a delta, and build the `avc1.PPCCLL` codec
// string VideoDecoder wants from the SPS.
export const NAL_IDR = 5;
export const NAL_SPS = 7;
/** NAL unit payloads (start codes stripped) of an Annex-B buffer. */
export function nalUnits(buf) {
    const units = [];
    let start = -1;
    let i = 0;
    while (i + 3 <= buf.length) {
        if (buf[i] === 0 && buf[i + 1] === 0 && buf[i + 2] === 1) {
            if (start >= 0) {
                let end = i;
                if (end > start && buf[end - 1] === 0)
                    end--; // 4-byte start code
                units.push(buf.subarray(start, end));
            }
            start = i + 3;
            i += 3;
        }
        else {
            i++;
        }
    }
    if (start >= 0 && start < buf.length)
        units.push(buf.subarray(start));
    return units;
}
export function nalType(nal) {
    return nal.length > 0 ? nal[0] & 0x1f : -1;
}
export function containsIdr(annexb) {
    return nalUnits(annexb).some((n) => nalType(n) === NAL_IDR);
}
/** `avc1.PPCCLL` from the first SPS in the access unit, or null. */
export function avcCodecString(annexb) {
    const sps = nalUnits(annexb).find((n) => nalType(n) === NAL_SPS);
    if (!sps || sps.length < 4)
        return null;
    const hex = (v) => v.toString(16).padStart(2, '0').toUpperCase();
    return `avc1.${hex(sps[1])}${hex(sps[2])}${hex(sps[3])}`;
}
//# sourceMappingURL=h264.js.map